/**
 * Formats a number with 2 decimal places and thousand separators
 */
export const formatAmount = (value) => {
  return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
